export class Metadata {
    group!: string;
    key!: string;
    value!: string;
}
